import { render, staticRenderFns } from "./v-file.vue?vue&type=template&id=bec47d3c&scoped=true&"
import script from "./v-file.vue?vue&type=script&lang=js&"
export * from "./v-file.vue?vue&type=script&lang=js&"
import style0 from "./v-file.vue?vue&type=style&index=0&id=bec47d3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec47d3c",
  null
  
)

export default component.exports